import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import VendorProfile from "../components/VendorProfile";

const VendorProfilePage = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>
                {/* Breadcrumb */}
                <Breadcrumb title='My Profile' />

                <VendorProfile />

            </MasterLayout>
        </>
    );
};

export default VendorProfilePage;
